/* Skeleton, EmptyState, ErrorState, Spinner and Stat — the loading, empty,
   error and partial states that every screen has to specify. */

.skeleton {
  background: linear-gradient(
    90deg,
    var(--surface-sunken) 25%,
    var(--border) 50%,
    var(--surface-sunken) 75%
  );
  background-size: 200% 100%;
  border-radius: var(--radius-sm);
  animation: shimmer var(--duration-shimmer) linear infinite;
}

@keyframes shimmer {
  to {
    background-position: -200% 0;
  }
}

/* Sized to the text it replaces, so resolving does not shift the line. */
.skeletonText {
  height: 1em;
}

.spinner {
  width: var(--space-5);
  height: var(--space-5);
  border: 2px solid var(--border);
  border-top-color: var(--text-secondary);
  border-radius: var(--radius-full);
  animation: spin var(--duration-spin) linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}

.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-7) var(--space-4);
  text-align: center;
}

.stateTitle {
  font-size: var(--text-lg);
  font-weight: var(--weight-semibold);
  color: var(--text-primary);
}

.stateBody {
  max-width: 42ch;
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.alert {
  display: flex;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
}

.alertInfo {
  background: var(--surface-sunken);
  border-color: var(--border);
  color: var(--text-primary);
}
.alertPositive {
  background: var(--surface-positive);
  border-color: var(--intent-positive);
  color: var(--text-primary);
}
.alertWarning {
  background: var(--surface-warning);
  border-color: var(--intent-warning);
  color: var(--text-primary);
}
.alertDanger {
  background: var(--surface-danger);
  border-color: var(--intent-danger);
  color: var(--text-primary);
}

.stat {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.statLabel {
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.statValue {
  font-size: var(--text-2xl);
  font-weight: var(--weight-semibold);
  line-height: var(--leading-tight);
}

.statMeta {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

/* A total that quietly omits an account is worse than no total. */
.statStale {
  color: var(--intent-warning);
}
